// The whole of teacher mode's menu, in the order it renders.

import { CalendarDays, Map } from 'lucide-react';

import type { NavLinkEntry, NavRailItem, NavTree } from './nav-tree.types';

const MY_SCHEDULE: NavRailItem = {
  id: 'my-schedule',
  label: 'My schedule',
  icon: CalendarDays,
  to: '/me/schedule',
};

const REGION_SCHEDULE: NavRailItem = {
  id: 'region-schedule',
  label: 'Region schedule',
  icon: Map,
  to: '/me/region-schedule',
};

export const TEACHER_NAV: NavTree = {
  entries: [
    { kind: 'link', ...MY_SCHEDULE } satisfies NavLinkEntry,
    { kind: 'link', ...REGION_SCHEDULE } satisfies NavLinkEntry,
  ],
  bottomTabs: [MY_SCHEDULE, REGION_SCHEDULE],
};
